<template>
  <div class="vh-100">
    <NuxtLink to="/" style="z-index:10 ;">
      <img src="./assets/logo.jpg" height="60" alt="" class="animate__animated animate__bounce
            animate__delay-4s animate__slow "> 
    </NuxtLink>
    
    <div class="">
      
      <div class="mt-5 px-5">
        <router-view></router-view>
      </div>
      <!-- <PartnersCardVue/>  -->
    </div> 
  </div>
</template>

<script>
import PartnersCardVue from './components/Cards/PartnersCard.vue';
export default {
  components: {
    PartnersCardVue,
  },
  data() {
    return {};
  },
  
};
</script>

<style>

</style>
